import React, { useEffect } from 'react';
import emailjs from 'emailjs-com';
import { Box, Button, Grid, TextField } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import EmailIcon from '@material-ui/icons/Email';
import { withStyles } from '@material-ui/core/styles';
import Aos from 'aos';
import { useTranslation } from 'react-i18next';
import { Link } from 'gatsby';
import ReCAPTCHA from 'react-google-recaptcha';
import ShapyaSpinner from '../../../images/shapya_spinner.gif';

import '../../styles/shapyaMaxWidth.css';
import 'aos/dist/aos.css';
import './InvestmentForm.css';

const CustomTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '#fff',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#fff',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#ffffff',
        borderRadius: '5px',
        padding: '20px',
      },
      '&:hover fieldset': {
        borderColor: '#fff',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#fff',
      },
    },
  },
})(TextField);

const recaptchareq = () => {
  const recaptchares = document.querySelector('#g-recaptcha-response');
  if (recaptchares) {
    recaptchares.setAttribute('required', 'required');
  }
};

const InvestmentForm = () => {
  useEffect(() => {
    Aos.init({ disable: 'mobile', duration: 2000, once: true });
  }, []);

  const { t } = useTranslation();

  function onChange(value) {
    console.log('Captcha value:', value);
  }

  function sendEmail(e) {
    e.preventDefault();
    const investmentButtonSubmit = document.getElementById(
      'investmentButtonSubmit',
    );

    emailjs
      .sendForm(
        'default_service',
        'investment_contact_form',
        e.target,
        'user_OWsnyBPupik9scReHvsc5',
      )
      .then(
        (result) => {
          console.log(result.text);
          setTimeout(() => {
            investmentButtonSubmit.setAttribute('disabled', 'true');
            investmentButtonSubmit.style.opacity = '0.5';
          }, 100);
          setTimeout(() => {
            document.getElementById('formloader').style.display = 'block';
          }, 100);
          setTimeout(() => {
            document.getElementById('linktm').click();
          }, 3500);
        },
        (error) => {
          console.log(error.text);
        },
      );
    e.target.reset();
  }

  return (
    <div className="shapyaMaxWidth" id="investmentForm">
      <Grid className="investmentFormMainGrid">
        <Box className="investmentFormTitle">
          {t('investmentOportunities.page.investmentForm.title')}
        </Box>
        <form onSubmit={sendEmail}>
          <Grid container className="investmentFormInputButtonGrid">
            <label className="customLabel" htmlFor="investment_name">
              {t('investmentOportunities.page.investmentForm.nameLabel')}
            </label>
            <CustomTextField
              id="investment_name"
              placeholder={t(
                'investmentOportunities.page.investmentForm.namePlaceholder',
              )}
              variant="outlined"
              color="secondary"
              type="text"
              name="investment_name"
              required
              autoComplete="off"
            />
            <label className="customLabel" htmlFor="investment_company">
              {t('investmentOportunities.page.investmentForm.companyLabel')}
            </label>
            <CustomTextField
              id="investment_company"
              placeholder={t(
                'investmentOportunities.page.investmentForm.companyPlaceholder',
              )}
              variant="outlined"
              color="secondary"
              type="text"
              name="investment_company"
              required
              autoComplete="off"
            />
            <label className="customLabel" htmlFor="investment_phone">
              {t('investmentOportunities.page.investmentForm.phoneLabel')}
            </label>
            <CustomTextField
              id="investment_phone"
              placeholder={t(
                'investmentOportunities.page.investmentForm.phonePlaceholder',
              )}
              variant="outlined"
              color="secondary"
              type="tel"
              name="investment_phone"
              required
              autoComplete="off"
            />
            <label className="customLabel" htmlFor="investment_email">
              {t('investmentOportunities.page.investmentForm.emailLabel')}
            </label>
            <CustomTextField
              id="investment_email"
              placeholder={t(
                'investmentOportunities.page.investmentForm.emailPlaceholder',
              )}
              variant="outlined"
              color="secondary"
              type="email"
              name="investment_email"
              required
              autoComplete="off"
              inputProps={{
                maxLength: 55,
                pattern:
                  '[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})',
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon className="investmentFormInputAdornment" />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              className="investmentFormButton"
              disableElevation
              type="submit"
              onClick={recaptchareq}
              id="investmentButtonSubmit"
            >
              {t('investmentOportunities.page.investmentForm.submitButton')}
            </Button>
          </Grid>
          <Grid item className="captchaGrid" xs={12}>
            <Box align="center" mt={2}>
              <ReCAPTCHA
                sitekey="6Lc0WWwaAAAAADbTnntpfueo8PdvKyGpVMqiX4mG"
                onChange={onChange}
                hl="en"
              />
              <Box color="#fff" id="recaptchafield">
                <small>
                  <b>{t('form.rightside.recaptchamsg')}</b>
                </small>
              </Box>
            </Box>
            <Link component="a" href="/thanksMessage/" id="linktm"></Link>
            <Box align="center" mt={2} id="formloader">
              <img src={ShapyaSpinner} width="120" alt="Loading spinner" />
            </Box>
          </Grid>
        </form>
      </Grid>
    </div>
  );
};

export default InvestmentForm;
